var exports = {
  "a": "Box__mT5P82",
  "w": "Box_1__1LiyRh",
};

module.exports = exports;
